const vars = {
  // Media
  breakpoints: {
    xsMobile: 325,
    sMobile: 375,
    mobile: 500,
    lMobile: 650,
    mTablet: 768,
    tablet: 1024,
    xsDesktop: 1280,
    sDesktop: 1366,
    mDesktop: 1440,
    desktop: 1920,
  },
  container: {
    maxWidth: 1300,
    minWidth: 280,
    spaceDesktop: 70,
    spaceXsDesktop: 60,
    spaceTablet: 40,
    spaceMobile: 20,
  },
}

export default vars
